export const SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  inherit: 'inherit',
};

export const APPEARANCES = {
  highEmphasis: 'high-emphasis',
  mediumEmphasis: 'medium-emphasis',
  lowEmphasis: 'low-emphasis',
  accent: 'accent',
  cta: 'cta',
  danger: 'danger',
  success: 'success',
  warning: 'warning',
  white: 'white',
  inherit: 'inherit',
};

export const TYPES = {
  paragraph: 'paragraph',
  listItem: 'list-item',
  link: 'link',
  label: 'label',
  mark: 'mark',
  heading: 'heading',
};

export const ALIGN = {
  left: 'left',
  center: 'center',
  right: 'right',
};
